export const SEND_TO_NEO_SIGNAL_LIMIT = 15;
export const SEND_TO_COPILOT_SIGNAL_LIMIT = 40;

export const SIGNALS_BULK_NEO_BLOCKER = {
  ALL_OUT_OF_TESTING_SCOPE: 'allOutOfTestingScope',
  OVER_LIMIT: 'overLimit',
} as const;

export type SignalsBulkNeoBlocker =
  (typeof SIGNALS_BULK_NEO_BLOCKER)[keyof typeof SIGNALS_BULK_NEO_BLOCKER];

export type SignalsBulkSendAvailability = {
  eligibleForNeoCount: number;
  skippedForNeoCount: number;
  neoBlocker: SignalsBulkNeoBlocker | null;
  isCopilotOverLimit: boolean;
};

export const resolveSignalsBulkSendAvailability = ({
  selectedCount,
  outOfTestingScopeCount,
}: {
  selectedCount: number;
  outOfTestingScopeCount: number;
}): SignalsBulkSendAvailability => {
  const skippedForNeoCount = Math.min(outOfTestingScopeCount, selectedCount);
  const eligibleForNeoCount = selectedCount - skippedForNeoCount;
  const neoBlocker =
    selectedCount > 0 && eligibleForNeoCount === 0
      ? SIGNALS_BULK_NEO_BLOCKER.ALL_OUT_OF_TESTING_SCOPE
      : selectedCount > SEND_TO_NEO_SIGNAL_LIMIT
        ? SIGNALS_BULK_NEO_BLOCKER.OVER_LIMIT
        : null;

  return {
    eligibleForNeoCount,
    skippedForNeoCount,
    neoBlocker,
    isCopilotOverLimit: selectedCount > SEND_TO_COPILOT_SIGNAL_LIMIT,
  };
};
